/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDeleteController', MemberManagementDeleteController);

    MemberManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'MemberManagement'];

    function MemberManagementDeleteController($uibModalInstance, entity, MemberManagement) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MemberManagement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
